<template>
  <v-fab-transition>
  <wgu-module-card v-bind="$attrs" moduleName="print-module" class="print-module" :icon="icon">
    <div class="ma-2">
    <v-btn @click="print(encodedExtent)"
      :loading="isLoading"
      :disabled="isLoading"
    >
      {{ $t('print-module.hint') }}
    </v-btn>
    <v-alert
      v-if="alerting"
      type="warning"
      class="mt-2"
    >
    {{ $t('print-module.alert') }}
    </v-alert>
  </div>
  </wgu-module-card>
</v-fab-transition>
</template>
<script>
import TileLayer from 'ol/layer/Tile';
import ModuleCard from '../src/components/modulecore/ModuleCard';
import { Mapable } from '../src/mixins/Mapable';
// import axios from 'axios';

export default {
  name: 'print-module',
  mixins: [Mapable],
  inheritAttrs: false,
  components: {
    'wgu-module-card': ModuleCard
  },
  props: {
    icon: { type: String, required: false, default: 'mdi-printer' },
    jasperUrl: { type: String, required: true, default: 'http://dockerhost02:6789' }
  },
  data () {
    return {
      // tracked current extent uri encoded
      encodedExtent: '',
      isLoading: false,
      alerting: false
    };
  },
  methods: {
    onMapBound () {
      const view = this.map.getView();
      this.extractMapViewProperties(view);
      view.on('change', () => {
        this.extractMapViewProperties(view);
      });
    },

    /**
     * We extract the current extent and layers
     * from the OpenLayers view and store the values
     *
     * @param {ol.View} view The OpenLayers view
     */
    extractMapViewProperties (view) {
      // get the extent of the current view
      const currExtent = view.calculateExtent(this.map.getSize());
      // round the extent coordinates to integers
      const roundedExtent = currExtent.map(coord => Math.round(coord));
      // turn the rounded extent into a URI encoded string
      this.encodedExtent = encodeURIComponent(roundedExtent.join(','));
    },

    /**
     * Provide params to jasper instance
     * TODO: provide streetcode
     * @param extent
     * @param inStreetCode
     */
    print (extent, inStreetCode) {
      // this.isLoading = true;

      // vis image layers without baselayers
      const visibleLayers = this.map.getLayers().getArray().filter(layer => {
        return layer.getVisible() && layer.get('printable') && (layer instanceof TileLayer);
      });

      const backgroundLayers = this.map.getLayers().getArray().filter(layer => {
        return layer.getVisible() && layer.get('isBaseLayer') && (layer instanceof TileLayer);
      }).map(
        layer => layer.get('printWMS')
      );

      // from them, get layer source.params.LAYERS for geoserver storename:layername
      const layerNames = backgroundLayers[0] + ',' + visibleLayers.map(layer => layer.getSource().getParams().LAYERS).join(',');

      const streetCode = inStreetCode || 0;

      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${this.jasperUrl}/jasper-reports/createReport?streetCode=${streetCode}&layerList=${layerNames}&bbox=${extent}`,
        headers: {}
      };

      window.open(config.url, 'myWin', '_blank');
      /*
      axios.request(config)
        .then(() => {
          window.open(config.url, 'myWin', '_blank');

          // Method Auto download
          // const linkElement = document.createElement('a');
          // linkElement.href = config.url;
          // linkElement.download = 'HWKarten.pdf';
          // linkElement.click();

          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.alerting = true;
        });
        */

      /* Method POST Form */
      /*
      const myWin = window.open('static/html/printForm.html', 'myWin', '_blank');
      myWin.document.getElementById('streetCode').value = '0';
      myWin.document.getElementById('layerList').value = layerNames;
      myWin.document.getElementById('bbox').value = extent;
      myWin.document.getElementById('myForm').onsubmit()
      */
    }
  }
};
</script>
<!-- Here we do the styling of our module -->
<style scoped>
/* our module has the class '.print-module' and we reference it here */
.print-module.wgu-floating {
  left: auto !important;
  top: 100px !important;
  right: 18px;
}
</style>
